module.exports = __webpack_public_path__ + "img/download_bg.06b1502f.png";